import React from "react";
import "../styles/LoadingBox.css";
function LoadingBox() {
  return (
    <div className="loadingBox">
      <div className="loading"></div>
    </div>
  );
}

export default LoadingBox;
